/* Fogonera — interacciones básicas del tema */
(function () {
  'use strict';

  // Botones − / + de cantidad
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 0;
    var value = parseInt(input.value, 10) || 0;
    value = btn.hasAttribute('data-qty-plus') ? value + 1 : Math.max(min, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Enviar el formulario al cambiar filtros, orden o cantidades del carrito
  var submitTimer;
  document.addEventListener('change', function (event) {
    var field = event.target.closest('[data-autosubmit]');
    if (!field || !field.form) return;
    var form = field.form;
    clearTimeout(submitTimer);
    submitTimer = setTimeout(function () {
      if (form.id === 'FacetForm') {
        var params = new URLSearchParams(new FormData(form));
        // Quita campos vacíos para no ensuciar la URL
        Array.from(params.keys()).forEach(function (key) {
          if (params.get(key) === '') params.delete(key);
        });
        window.location.search = params.toString();
      } else {
        form.submit();
      }
    }, 450);
  });

  // Galería de producto: miniaturas
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-gallery-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('.gallery');
    var main = gallery && gallery.querySelector('[data-gallery-main] img');
    if (!main) return;
    main.removeAttribute('srcset');
    main.src = thumb.getAttribute('data-src');
    main.alt = thumb.getAttribute('data-alt') || '';
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t === thumb);
    });
  });

  // Cerrar menús desplegables al hacer clic fuera o pulsar Escape
  function closeOpenMenus(except) {
    document.querySelectorAll('.nav-dropdown[open], .mobile-menu[open]').forEach(function (d) {
      if (d !== except && !d.contains(except)) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', function (event) {
    var inside = event.target.closest('.nav-dropdown, .mobile-menu__panel, .mobile-menu > summary');
    if (!inside) closeOpenMenus(null);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeOpenMenus(null);
  });
  document.addEventListener('toggle', function (event) {
    var el = event.target;
    if (el.classList && el.classList.contains('nav-dropdown') && el.open) closeOpenMenus(el);
  }, true);
})();
